import { render, staticRenderFns } from "./PhoneVerifyModal.vue?vue&type=template&id=0edcae36&"
import script from "./PhoneVerifyModal.vue?vue&type=script&lang=js&"
export * from "./PhoneVerifyModal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVerifyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports